import { NgModule } from '@angular/core';
import { mapToCanActivate, RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard } from '@okta/okta-angular';
import { TabTitleStrategyService } from '@sc/data-access-translation';
import {
  CustomAuthCallbackComponent,
  FitterXGuard,
  HoldGuard,
  InsurerXGuard,
} from '@sc/feature-auth-okta';
import { routes as declarationRoutes } from '@sc/feature-insurer-declaration';

const CALLBACK_PATH = 'login/callback';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'declaration',
    loadChildren: () =>
      import('@sc/feature-insurer-declaration').then((module) => module.routes),
    canActivate: [
      HoldGuard,
      InsurerXGuard,
      ...mapToCanActivate([OktaAuthGuard]),
    ],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.CustomerDataForm',
      childRoutes: declarationRoutes,
      sitePlanConfig: {
        display: true,
        displayName:
          'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.CustomerDataFormSitePlan',
      },
    },
  },
  {
    path: 'administration',
    loadChildren: () =>
      import('@sc/feature-admin-page').then((module) => module.routes),
    canActivate: [
      HoldGuard,
      InsurerXGuard,
      ...mapToCanActivate([OktaAuthGuard]),
    ],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.Administration',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('@sc/feature-insurer-dashboard').then((module) => module.routes),
    canActivate: [
      HoldGuard,
      InsurerXGuard,
      ...mapToCanActivate([OktaAuthGuard]),
    ],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.Dashboard',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: 'partners',
    loadChildren: () =>
      import('@sc/feature-partner-fitter').then((module) => module.routes),
    canActivate: [
      HoldGuard,
      InsurerXGuard,
      ...mapToCanActivate([OktaAuthGuard]),
    ],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.Partners',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: 'dossiers-search',
    loadChildren: () =>
      import('@sc/feature-insurer-dossier-search').then(
        (module) => module.routes
      ),
    canActivate: [
      HoldGuard,
      InsurerXGuard,
      ...mapToCanActivate([OktaAuthGuard]),
    ],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.DossierSearch',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: 'login',
    loadChildren: () =>
      import('@sc/feature-login').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.Login',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: 'site-plan',
    loadChildren: () =>
      import('@sc/feature-insurer-site-plan').then((module) => module.routes),
    canActivate: [HoldGuard, ...mapToCanActivate([OktaAuthGuard])],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.SitePlan',
      sitePlanConfig: {
        display: true,
      },
    },
  },
  {
    path: 'cta/:encryptedInfo',
    loadChildren: () =>
      import('@sc/feature-cta-insurer').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.Home',
    },
  },
  {
    path: 'cta',
    loadChildren: () =>
      import('@sc/feature-cta-insurer').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.Home',
    },
  },
  {
    path: 'folder',
    loadChildren: () =>
      import('@sc/feature-folder-summary').then((module) => module.routes),
    canActivate: [
      HoldGuard,
      FitterXGuard,
      ...mapToCanActivate([OktaAuthGuard]),
    ],
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.insurer.FitterFolderSummary',
    },
  },
  {
    path: CALLBACK_PATH,
    component: CustomAuthCallbackComponent,
  },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
